import { render } from "./logs-view-page.vue?vue&type=template&id=c3a30386"
import script from "./logs-view-page.vue?vue&type=script&lang=ts"
export * from "./logs-view-page.vue?vue&type=script&lang=ts"

import "./logs-view-page.vue?vue&type=style&index=0&id=c3a30386&lang=less"
script.render = render

export default script